export var APIEvents;
(function (APIEvents) {
    APIEvents["REQUEST_COMPLETE"] = "@sydle/one-api:request-complete";
    APIEvents["REQUEST_INCOMPLETE"] = "@sydle/one-api:request-incomplete";
    APIEvents["REQUEST_COMPLETE_SUCCESS"] = "@sydle/one-api:request-complete-success";
    APIEvents["REQUEST_COMPLETE_ERROR"] = "@sydle/one-api:request-complete-error";
    APIEvents["EXPIRING_SESSION"] = "@sydle/one-api:expiring-session";
    APIEvents["UNAUTHORIZED"] = "@sydle/one-api:unauthorized";
    APIEvents["FORBIDDEN"] = "@sydle/one-api:forbidden";
    APIEvents["LANGUAGE_DID_CHANGE_EVENT"] = "@sydle/one-api:language-did-change";
    APIEvents["INVALID_TOKEN"] = "@sydle/one-api:invalid-token";
})(APIEvents || (APIEvents = {}));
